import { PersonHttpHelper, NO_DATA_MESSAGE } from '../../../../utils/HttpHelper';
import { isValidMemberId } from '../../../../utils/validation';

export const localValidate = async (formState) => {
  let errors = {};

  if (formState.memberId.trim() === '') {
    errors.memberId = 'Member Id is required';
  } else if (!isValidMemberId(formState.memberId.trim())) {
    errors.memberId = 'Member Id must be 14 alphanumeric characters';
  }

  return errors;
};

const serverValidate = async (formState) => {
  let errors = {};

  const memberIdForUrl = formState.memberId ? encodeURIComponent(formState.memberId) : 'NaN';
  await PersonHttpHelper(`/Person/flat/memberId/${memberIdForUrl}`, 'GET')
    .then((objData) => {
      if (!objData) {
        throw new Error(NO_DATA_MESSAGE);
      }
      else {
        if (!(objData.personId)) {
          errors.memberId = "Member Id is not valid";
        } else {
          formState.personId = objData.personId;
        }
      }
    })
    .catch(() => {
      errors.memberId = 'Member Id is not valid';
    });

  return errors;
};

const PayByCheckValidation = async (formState) => {
  let errors = await localValidate(formState);
  
  if (!errors || Object.keys(errors).length === 0) {
    errors = await serverValidate(formState);
  }

  return errors ? errors : {};
};

export default PayByCheckValidation;